module.exports = __webpack_public_path__ + "static/media/SilverMedal.33bd6aeb.png";